import styled from 'styled-components';
import { colors, transitions, shadows } from '../../theme/tokens';
import { panelSurface } from '../../theme/mixins';

export const ListPanel = styled.div`
  ${panelSurface};
  padding: 0;
  overflow-x: auto;
  box-shadow: ${shadows.level2};
`;

export const ListTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  color: ${colors.text.secondary};
`;

export const ListHeadRow = styled.tr`
  background: ${colors.surface.subtle};
`;

export const ListHeadCell = styled.th<{ $align?: 'left' | 'right' }>`
  padding: 12px 16px;
  font-weight: 600;
  color: ${colors.text.secondary};
  text-align: ${({ $align }) => $align ?? 'left'};
  border-bottom: 1px solid ${colors.border.subtle};
`;

export const ListRow = styled.tr<{ $active?: boolean; $clickable?: boolean }>`
  background: ${({ $active }) => ($active ? colors.backgroundTones.primarySoft : colors.surface.base)};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: background ${transitions.default};

  &:hover {
    background: ${({ $active }) => ($active ? colors.backgroundTones.primarySoft : colors.surface.subtle)};
  }

  &:focus-visible {
    outline: 2px solid ${colors.accents.primary};
    outline-offset: -2px;
  }

  &:not(:last-child) td {
    border-bottom: 1px solid ${colors.border.table};
  }
`;

export const ListCell = styled.td<{ $align?: 'left' | 'right' }>`
  padding: 14px 16px;
  color: ${colors.text.secondary};
  vertical-align: top;
  text-align: ${({ $align }) => $align ?? 'left'};
  white-space: ${({ $align }) => ($align === 'right' ? 'nowrap' : 'normal')};
`;

export const ListActionsCell = styled(ListCell)`
  text-align: right;
  white-space: nowrap;
`;
